import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Layout } from '../components/layout/Layout';
import { EstimatorWidget } from '../components/estimator/EstimatorWidget';
import { LiveEstimatorFlow } from '../components/live-estimator/LiveEstimatorFlow';

type Mode = 'photo' | 'live';

interface HomeDetails {
  rooms:        string[];
  cleaningType: string;
  bedrooms:     number;
  bathrooms:    number;
  sqftRange:    string;
}

export function EstimatorPage() {
  const [mode, setMode] = useState<Mode>('photo');
  const [liveDetails, setLiveDetails] = useState<HomeDetails | null>(null);

  useEffect(() => { window.scrollTo(0, 0); }, []);

  const handleStartLive = (details: HomeDetails) => {
    setLiveDetails(details);
    setMode('live');
  };

  return (
    <Layout>
      <Helmet>
        <title>Free Cleaning Estimate — MaidLink Calgary</title>
        <meta name="description" content="Get a free AI-powered home cleaning estimate in 2 minutes. Upload photos or enter your home details — standard, deep, or move-out cleaning in Calgary." />
        <meta property="og:title" content="Free Cleaning Estimate — MaidLink Calgary" />
        <meta property="og:description" content="Get a free AI-powered home cleaning estimate in 2 minutes. No sign-up needed." />
        <meta property="og:url" content="https://maidlink.ca/estimate" />
        <link rel="canonical" href="https://maidlink.ca/estimate" />
      </Helmet>

      {(mode === 'photo' || !liveDetails) && (
        <EstimatorWidget
          mode={mode}
          onModeChange={(m) => setMode(m as Mode)}
          onStartLive={handleStartLive}
        />
      )}
      {mode === 'live' && liveDetails && (
        <div className="max-w-5xl mx-auto px-4 pb-12">
          <LiveEstimatorFlow
            initialHomeDetails={liveDetails}
            onBack={() => { setMode('photo'); setLiveDetails(null); }}
          />
        </div>
      )}
    </Layout>
  );
}
